<template>
  <div class="login-container">
    <div class="login-box">
      <div class="merchant-detail">
        <img
          class="merchant-logo"
          crm_at="image_logo"
          alt=""
          :src="storeinfo.image_logo"
        />
        <div class="text-title" crm_at="title">
          {{ lbl.default.welcome }}<br />
          {{ storeinfo.businessName }}
        </div>
      </div>
      <hr />
      <div class="input-wrapper">
        <div class="title-page">
          {{ lbl.otp_flow.otp.title }}
        </div>
        <div class="desc-page">
          {{ lbl.otp_flow.otp.desc }}
        </div>
        <div class="otp-detail">
          <div v-if="otpRequest" class="refcode" crm_at="refcode_detail">
            {{ lbl.otp_flow.otp.refcode_is }}
            <span v-if="otpRequest.refcode" crm_at="refcode">
              {{ otpRequest.refcode }}
            </span>
          </div>
          <p v-if="!isOtpExpied" crm_at="expire_date" class="expired">
            <img src="@/assets/images/restore_red.svg" alt="" />
            {{ lbl.otp_flow.otp.expired_in }}
            <span class="time-expired" crm_at="time_expired">
              {{ detail_otp.remain_time }}
            </span>
          </p>
        </div>
        <div class="otp-input-wrapper" crm_at="otp_input_wrapper">
          <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            crm_at="otp_input"
            style="justify-content: center;"
            :class="{ 'input-expied': isOtpExpied }"
            separator=""
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
          />
        </div>
        <div v-if="isOtpError" class="error-massage">{{ otpErrorText }}</div>
      </div>
      <div class="resent-otp" crm_at="resent_otp" @click="resentOTP()">
        {{ lbl.otp_flow.otp.resent_otp }}
      </div>
      <div class="button-wrapper">
        <a-button
          :style="{
            backgroundColor: storeinfo.buttoncolor,
            border: storeinfo.buttoncolor,
            color: storeinfo.buttontextcolor,
          }"
          crm_at="request_otp"
          type="submit"
          value="Submit"
          class="login-button"
          :disabled="checkInput || detail_otp.is_timeout"
          @click="confirmOTP()"
        >
          {{ lbl.otp_flow.otp.submit_btn }}
        </a-button>
      </div>
    </div>
    <div v-if="isshowalert">
      <AlertErrormodal
        v-if="isshowalert && errors.length > 0"
        :isshowalert="isshowalert"
        :modalcontent="errors"
        :title="title"
        @ChangeAlertError="ChangeAlertError($event)"
      />
    </div>

    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
  </div>
</template>

<script>
import AlertError from '@/components/Modal/AlertError'
import AlertErrormodal from '@/components/Modal/AlertErrormodal'
import BzbsAuth from '@/core/Account/service/BzbsAuth.js'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsProfile from '@/core/Account/service/BzbsProfile.js'
import Account from '@/helper/AccountHelper.js'
import CheckCookie from '@/mixin/CheckCookie'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'OTP',
  components: {
    AlertErrormodal,
    AlertError,
  },
  mixins: [CommonMixin, ResponsiveMixin, CheckCookie],
  data() {
    return {
      otpRequest: JSON.parse(localStorage.getItem('requestOTP')),
      isOtpExpied: false,
      please_otp: '',
      validat_otp: '',
      text_btn_submit: '',
      detail_otp: {
        otp_code: '',
        refcode: '',
        remain_time: '00:00',
        phone_no: '',
        is_timeout: false,
        countdown_limit_sec: 420,
        remain_sec: 0,
        interval: null,
        otp_phone_no: '',
      },
      isOtpError: false,
      otpErrorText: '',
      otpValue: null,
      isDisplayTermandPrivacy: true,
      isDisplayAgeCondition: true,
      isDisplayMarketing: true,
      isRequiredTermandPrivacy: true,
      isRequiredAgeCondition: true,
      isRequiredMarketing: true,

      storeinfo: {
        image_logo: '',
        businessName: '',
        buttoncolor: '',
        buttontextcolor: '',
      },

      isshowalert: false,
      errors: [],
      dataError: {},
      showError: false,
      loginType: '',
      isSentOtp: false,
      connectLine: false,
    }
  },
  computed: {
    checkInput() {
      if (this.checkOTPLength(this.otpValue) < 6) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.please_otp = this.lbl.otp.desc
    this.validat_otp = this.lbl.otp.otpincorrect
    this.text_btn_submit = this.lbl.otp.submit
  },
  created() {
    this.$store.commit('FooterMenu', false)
    if (this.$route.query.connect_line) {
      this.connectLine = true
    }
    this.checklocalStorage().then(() => {
      Account.removeCacheCustom(
        'setRegister_' + Account.getCacheCustom('app_id'),
      )
      this.init()
    })
  },

  methods: {
    init() {
      console.log('otpRequest ::', this.otpRequest)
      if (!this.otpRequest) {
        this.$router.push({ name: 'loginOTP' })
      }

      var now = moment().format('MMMM Do YYYY, h:mm:ss a')
      var expiredate = moment
        .unix(this.otpRequest.expiredate)
        .format('MMMM Do YYYY, h:mm:ss a')
      if (moment(expiredate).isAfter(moment(now))) {
        localStorage.removeItem('requestOTP')
        this.$router.push({ name: 'loginOTP' })
      }
      this.handleCheckAppId(this.$route)
      this.initializeClock(this.otpRequest.expireinseconds)
      if (
        Account.getCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ) != null
      ) {
        if (
          Account.getCacheCustom('BzbsUser_' + Account.getCacheCustom('app_id'))
            .appId == null
        ) {
          window.location.href = '/error/404'
        } else {
          this.AppId = Account.getCacheCustom(
            'BzbsUser_' + Account.getCacheCustom('app_id'),
          ).appId
        }
      } else {
        window.location.href = '/error/404'
      }
      this.handleLanguage(true)
      this.handleLoading(false)
      this.getCustomerStore()
    },
    onlyNumber($event) {
      const regex = /^[0-9]\d*$/
      var match = $event.key.match(regex)

      if (match == null) {
        $event.preventDefault()
      }
    },
    checkOTPLength(value) {
      if (value) {
        return value.toString().length
      } else {
        return 0
      }
    },
    initializeClock(expiredate) {
      console.log(expiredate)
      var otp_remain_sec = expiredate
      this.detail_otp.is_timeout = false
      this.clearInterval()

      this.detail_otp.interval = setInterval(() => {
        this.detail_otp.remain_time = otp_remain_sec
        otp_remain_sec = otp_remain_sec - 1
        var remain_sec = otp_remain_sec
        if (remain_sec < 0) {
          remain_sec = 0
        }

        this.detail_otp.remain_time = this.getDigitFormatTime(remain_sec)
        if (remain_sec <= 0) {
          this.detail_otp.is_timeout = true
          this.clearInterval()
          this.validat_otp = this.lbl.otp.otpexpire
          this.changebtntext(true)
        }
      }, 1000)
    },
    clearInterval() {
      try {
        if (this.detail_otp.interval) {
          clearInterval(this.detail_otp.interval)
        }
      } catch (e) {
        //console.log(e.message);
      }
    },
    changebtntext(fact) {
      this.isOtpExpied = fact
    },
    getDigitFormatTime(remain) {
      var minutes = Math.floor(remain / 60)
      var secs = remain % 60
      return this.harold(minutes) + ':' + this.harold(secs)
    },
    harold(standIn) {
      if (standIn < 10) {
        standIn = '0' + standIn
      }
      return standIn
    },
    handleOnComplete(value) {
      this.detail_otp.otp_code = value
      this.otpValue = value
      if (value.length == 6 && !this.detail_otp.is_timeout)
        this.confirmOTP(value)
    },
    handleOnChange(value) {
      console.log('OTP changed: ', value)
      this.isOtpError = false
      this.otpValue = value
      this.please_otp = this.lbl.otp.desc
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput()
    },
    GetOTP() {
      this.handleLoading(true)
      var channel
      if (this.ArrList(this.loginType).includes('Line')) {
        channel = 'register'
      } else {
        channel = 'login'
      }
      var otp_params = {
        contact_number: this.otpRequest.contactnumber,
        app_id: Account.getCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ).appId,
        channel: channel,
      }

      BzbsAuth.apiRequestOTP(otp_params)
        .then(res => {
          console.log('apiRequestOTP res ::', res.data)
          this.isOtpExpied = false
          var data = {
            expiredate: res.data.expiredate,
            expireinseconds: res.data.expireinseconds,
            refcode: res.data.refcode,
            contactnumber: this.otpRequest.contactnumber,
          }
          localStorage.setItem('requestOTP', JSON.stringify(data))
          this.handleClearInput()
          this.otpRequest = data
          this.initializeClock(this.otpRequest.expireinseconds)
          this.handleLoading(false)
        })
        .catch(error => {
          this.handleLoading(false)
          if (!_.isEmpty(error.response.data.error)) {
            if (error.response.data.error.message == 'SMS is exceed limit') {
              window.location.href = '/limitotp'
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            }
          } else {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.connectionproblem,
            }
          }
        })
    },
    confirmOTP(strOTP) {
      var paramVerifyOtp = {
        app_id: Account.getCacheCustom('app_id'),
        contact_number: this.otpRequest.contactnumber,
        otp: strOTP ? strOTP : this.otpValue,
        refcode: this.otpRequest.refcode,
        use: false,
        channel: 'register',
      }
      var paramDeviceLogin = {
        appId: Account.getCacheCustom('app_id'),
        contactNumber: this.otpRequest.contactnumber,
        otp: strOTP ? strOTP : this.otpValue,
        refcode: this.otpRequest.refcode,
      }
      if (this.ArrList(this.loginType).includes('Line')) {
        if (this.connectLine) {
          this.callApiDeviceLogin(paramDeviceLogin)
        } else {
          this.verifyOtp(paramVerifyOtp)
        }
      } else {
        this.callApiDeviceLogin(paramDeviceLogin)
      }
    },
    verifyOtp(params) {
      this.handleLoading(true)
      BzbsAuth.apiConfirmOTP(params)
        .then(res => {
          if (res.data.validatecode) {
            console.log('apiConfirmOTP res::', res)
            if (this.$route.query.refcode) {
              window.location =
                '/termandcondition?single_signon=true&refcode=' +
                this.otpRequest.refcode +
                '&otp=' +
                this.otpValue +
                '&mobile=' +
                this.otpRequest.contactnumber +
                '&id_token=' +
                this.$route.query.id_token +
                '&refusercode=' +
                this.$route.query.refcode
            } else {
              window.location =
                '/termandcondition?single_signon=true&refcode=' +
                this.otpRequest.refcode +
                '&otp=' +
                this.otpValue +
                '&mobile=' +
                this.otpRequest.contactnumber +
                '&id_token=' +
                this.$route.query.id_token
            }
          }
        })
        .catch(error => {
          console.log('verifyOtp error :: ', error)
          if (error.response.data.error.message == 'SMS is exceed limit') {
            window.location.href = '/limitotp'
          } else {
            this.handleLoading(false)
            if (error.response.data.error.id == 2091) {
              this.isOtpError = true
              this.otpErrorText = error.response.data.error.message
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message
                  ? error.response.data.error.message
                  : this.lbl.error.connectionproblem,
              }
            }
          }
        })
    },
    callApiDeviceLogin(data) {
      this.handleLoading(true)
      return new Promise((resolve, reject) => {
        BzbsAuth.apiDeviceLogin(data)
          .then(res => {
            console.log('apiDeviceLogin : ', res.data)
            this.isOtpError = false
            // Account.setCacheToken(res.data.token)

            // LINE OTP FLOW
            if (
              this.ArrList(this.loginType).includes('Line') &&
              this.ArrList(this.loginType).includes('Device')
            ) {
              this.lineLogin(res.data.token)
            }

            // OTP STANDALONE FLOW
            if (
              !this.ArrList(this.loginType).includes('Line') &&
              this.ArrList(this.loginType).includes('Device')
            ) {
              this.standaloneLogin(res.data)
            }
            resolve(true)
          })
          .catch(error => {
            this.handleLoading(false)
            if (
              error.response.data.error &&
              error.response.data.error.code === 409 &&
              error.response.data.error.message == 'Unregistered'
            ) {
              if (this.ArrList(this.loginType).includes('Line')) {
                if (this.$route.query.refcode) {
                  window.location =
                    '/termandcondition?single_signon=true&refcode=' +
                    this.otpRequest.refcode +
                    '&otp=' +
                    this.otpValue +
                    '&mobile=' +
                    this.otpRequest.contactnumber +
                    '&id_token=' +
                    this.$route.query.id_token +
                    '&refusercode=' +
                    this.$route.query.refcode
                } else {
                  window.location =
                    '/termandcondition?single_signon=true&refcode=' +
                    this.otpRequest.refcode +
                    '&otp=' +
                    this.otpValue +
                    '&mobile=' +
                    this.otpRequest.contactnumber +
                    '&id_token=' +
                    this.$route.query.id_token
                }
              } else {
                if (this.$route.query.refcode) {
                  window.location =
                    '/termandcondition?single_signon=true&refcode=' +
                    this.otpRequest.refcode +
                    '&otp=' +
                    this.otpValue +
                    '&mobile=' +
                    this.otpRequest.contactnumber +
                    '&id_token=' +
                    this.otpRequest.contactnumber +
                    '&refusercode=' +
                    this.$route.query.refcode
                } else {
                  window.location =
                    '/termandcondition?single_signon=true&refcode=' +
                    this.otpRequest.refcode +
                    '&otp=' +
                    this.otpValue +
                    '&mobile=' +
                    this.otpRequest.contactnumber +
                    '&id_token=' +
                    this.otpRequest.contactnumber
                }
              }
            } else if (
              error.response.data.error &&
              error.response.data.error.code == 409
            ) {
              this.isOtpError = true
              this.otpErrorText = error.response.data.error.message
            } else if (
              error.response.data.error &&
              error.response.data.error.code !== 409
            ) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            reject(error)
          })
      })
    },
    standaloneLogin(response) {
      console.log('Standalone!!!!!!')
      Account.setCacheUser(response)
      Account.setCacheToken(response.token)
      Account.setCacheWalletToken(response.ewallet_token)

      this.checkAcceptConsent(response.token).then(result => {
        if (
          this.isDisplayTermandPrivacy ||
          this.isDisplayAgeCondition ||
          this.isDisplayMarketing
        ) {
          if (result) {
            window.location = '/home'
          } else {
            if (this.$route.query.refcode) {
              window.location =
                '/termandcondition?single_signon=true' +
                '&refusercode=' +
                this.$route.query.refcode
            } else {
              window.location = '/termandcondition?single_signon=true'
            }
          }
        } else {
          window.location = '/home'
        }
      })
    },
    lineLogin(token) {
      var params = {
        app_id: Account.getCacheCustom('app_id'),
        id_token: this.$route.query.id_token,
      }
      BzbsAuth.apilineotpdirectlogin(params, token)
        .then(response_line => {
          this.handleLoading(false)
          console.log('response_line ::', response_line)
          // Account.setCacheUser(response_line.data)
          Account.setCacheToken(response_line.data.token)
          Account.setCacheWalletToken(response_line.data.ewallet_token)
          if (this.connectLine) {
            this.checkAcceptConsent(token).then(result => {
              if (
                this.isDisplayTermandPrivacy ||
                this.isDisplayAgeCondition ||
                this.isDisplayMarketing
              ) {
                if (result) {
                  window.location = '/home'
                } else {
                  if (this.$route.query.refcode) {
                    window.location =
                      '/termandcondition?single_signon=true' +
                      '&refusercode=' +
                      this.$route.query.refcode
                  } else {
                    window.location = '/termandcondition?single_signon=true'
                  }
                }
              } else {
                window.location = '/home'
              }
            })
          }

          if (this.$route.query.refcode) {
            window.location =
              '/termandcondition?single_signon=true' +
              '&refusercode=' +
              this.$route.query.refcode
          } else {
            window.location = '/termandcondition?single_signon=true'
          }
        })
        .catch(error => {
          this.handleLoading(false)
          if (!_.isEmpty(error.response.data.error)) {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
          }
          if (
            _.isEmpty(error.response) ||
            _.isEmpty(error.response.data.error)
          ) {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.connectionproblem,
            }
          }
        })
    },
    checkAcceptConsent(token) {
      return new Promise(resolve => {
        BzbsProfile.getAcceptanceConsent(token)
          .then(res => {
            if (res.data.TermAndCondition || res.data.DataPrivacy) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch(() => {
            resolve(false)
          })
      })
    },
    ArrList(string) {
      var list = string.split(',')
      return list
    },
    ChangeCloseOtp(event) {
      this.isSentOtp = event.value
      if (event.error) {
        this.showError = true
        this.dataError = {
          title: this.lbl.error.errortitle,
          detail: event.error,
        }
      }
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.genInfo(res)
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail:
                error.response.data.error.message ||
                this.lbl.error.connectionproblem,
            }
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    async genInfo(res) {
      this.loginType = res.data.StoreDetail.LoginType
      this.storeinfo.image_logo = res.data.StoreDetail.LogoUrl
      this.storeinfo.businessName = res.data.StoreDetail.BusinessName
      this.storeinfo.buttoncolor = res.data.StoreDetail.ButtonColor
      this.storeinfo.buttontextcolor = res.data.StoreDetail.ButtonTextColor
      this.isDisplayTermandPrivacy =
        res.data.StoreDetail.DisplayTermAndCondition
      this.isDisplayAgeCondition = res.data.StoreDetail.DisplayConsentAge
      this.isDisplayMarketing = res.data.StoreDetail.DisplayMarketingMessage
      this.isRequiredTermandPrivacy =
        res.data.StoreDetail.RequireTermAndCondition
      this.isRequiredAgeCondition = res.data.StoreDetail.RequireConsentAge
      this.isRequiredMarketing = res.data.StoreDetail.RequireMarketingMessage
    },
    resentOTP() {
      console.log('click resent OTP')
      this.GetOTP()
    },

    //Error
    ChangeAlertError(value) {
      this.isshowalert = value
    },
    ChangeError(event) {
      this.showError = event
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
.login-container {
  height: 100vh;
  background-color: #ffffff;
  padding: 16px;
  padding-bottom: 40px;
  overflow: auto;
  position: relative;

  .login-box {
    max-width: 500px;
    .merchant-detail {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 24px;

      .merchant-logo {
        width: 80px;
        height: 80px;
        border-radius: 1000px;
        object-fit: contain;
      }
      .text-title {
        font-size: 28px;
        line-height: 1.35;
        font-weight: bold;
        color: #424242;
      }
    }
    .input-wrapper {
      position: relative;
      margin-top: 24px;

      .title-page {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 0;
      }
      .desc-page {
        color: #757575;
        margin-bottom: 24px;
      }
      .otp-detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        font-weight: 500;
        .refcode {
          color: #616161;
        }
        .expired {
          color: $color-error;
        }
      }
      .form-input-otp {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .otp__input {
          width: 80%;
        }
        .otp__input div {
          margin: 0 4px;
        }
      }
      .input-expied {
        opacity: 1;
      }
      .otp-input {
        height: 50px;
        width: 50px;
        border-radius: 4px;
        background-color: #fafafa;
        border: 1px solid #e8e8e8;
        color: #616161;
        margin: 0 4px;
        text-align: center;
        font-size: 18px;
        &.error {
          border: 1px solid $color-error !important;
        }
      }
      .send-otp-again {
        text-align: -webkit-center;
        margin: 16px 0 0;
        .btn-submit-otp {
          color: #bdbdbd;
          width: 200px;
          height: 52px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 100px;
          cursor: pointer;
          font-size: 18px;
        }
        .disable-submit {
          opacity: 0.7;
        }
      }
      .error-massage {
        position: absolute;
        bottom: -32px;
        width: 100%;
        color: $color-error;
      }
    }
    .login-option {
      display: flex;
      flex-flow: wrap;
      justify-content: space-between;
      font-size: 14px;
    }
    .resent-otp {
      text-align: center;
      color: #2196f3;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 1px;
      text-decoration-line: underline;
      margin-top: 48px;
    }
    .button-wrapper {
      margin-top: 24px;
      text-align: center;

      .login-button {
        position: fixed;
        bottom: 58px;
        left: 50%;
        transform: translate(-50%, 0);
        width: calc(100% - 32px);
        height: 50px;
        border-radius: 100px;
      }
      .login-button:disabled {
        opacity: 0.5;
      }

      .login-facebook-button {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px #c9c9c9;
        background-color: #fff;
      }

      .or-text {
        margin: 18px auto 8px;
      }
    }
    .not-have-account {
      width: 100%;
      display: flex;
      flex-flow: wrap;
      justify-content: center;
      gap: 16px;
      margin: 32px auto 16px;
    }

    .link-text {
      cursor: pointer;
      font-style: italic;
      color: #1890ff;
      text-decoration: underline;
    }
  }

  @include breakpoint-min(500) {
    text-align: center;
    text-align: -webkit-center;
  }
}
</style>
